var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{staticClass:"ms-loader",style:({height: `${_vm.getRandomHeight()}px`})},[_c('spin',{attrs:{"size":"large"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }